// Long-form guides. They are English-only, so they always live at their English
// URL (no /:lang prefix) and are pre-rendered once.
export type Guide = {
  path: string
  title: string
  description: string
}

export const GUIDES_PATH = '/learn'

export const GUIDES: Guide[] = [
  {
    path: '/learn/shot-clock-history',
    title: 'The History of the 24-Second Shot Clock',
    description:
      'How a team owner’s arithmetic ended the stalling era in 1954, and how the shot clock spread from the NBA to FIBA, college basketball, and beyond.',
  },
  {
    path: '/learn/shot-clock-rules-by-league',
    title: 'Shot Clock Rules Compared: FIBA vs NBA vs WNBA vs NCAA',
    description:
      'Possession length, reset values, backcourt counts, and game format side by side — plus what changes for an operator moving between competitions.',
  },
  {
    path: '/learn/14-second-reset',
    title: 'The 14-Second Reset Explained',
    description:
      'When the shot clock goes to 14 instead of 24, when it does not, why the rule exists, and how to make the call correctly at the scorer’s table.',
  },
  {
    path: '/learn/eight-second-rule',
    title: 'The 8-Second Rule and the Shot Clock',
    description:
      'What the 8-second backcourt rule requires, when the count restarts or continues, and how it lines up with the shot clock at the scorer’s table.',
  },
  {
    path: '/learn/shot-clock-operator-mistakes',
    title: '10 Common Shot Clock Operator Mistakes (and How to Avoid Them)',
    description:
      'The errors that come up most often at the scorer’s table — from starting on the throw to resetting on the backboard — and the habit that prevents each one.',
  },
  {
    path: '/learn/last-two-minutes',
    title: 'The Last Two Minutes: Clock Rules at the End of a FIBA Game',
    description:
      'How the game clock, time-outs, and shot clock resets change when 2:00 or less remains in the fourth quarter or overtime — with a checklist for the table.',
  },
]

export const PUBLISHED_DATE = '2026-10-25'
export const PUBLISHED_LABEL = 'October 25, 2026'
